import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

export type SuggestedTier = 'pro' | 'premium';

interface UpgradeModalContextType {
  isOpen: boolean;
  suggestedTier: SuggestedTier | null;
  openUpgradeModal: (suggested?: SuggestedTier) => void;
  closeUpgradeModal: () => void;
}

const UpgradeModalContext = createContext<UpgradeModalContextType>({
  isOpen: false,
  suggestedTier: null,
  openUpgradeModal: () => {},
  closeUpgradeModal: () => {},
});

export const useUpgradeModal = () => useContext(UpgradeModalContext);

export const UpgradeModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [suggestedTier, setSuggestedTier] = useState<SuggestedTier | null>(null);

  const openUpgradeModal = useCallback((suggested?: SuggestedTier) => {
    setSuggestedTier(suggested ?? null);
    setIsOpen(true);
  }, []);
  const closeUpgradeModal = useCallback(() => {
    setIsOpen(false);
    setSuggestedTier(null);
  }, []);

  return (
    <UpgradeModalContext.Provider value={{ isOpen, suggestedTier, openUpgradeModal, closeUpgradeModal }}>
      {children}
    </UpgradeModalContext.Provider>
  );
};
